import React, {useState} from 'react';
import {Layout, MenuItemLink, Menu} from 'react-admin';
import SubMenu from './SubMenu'
import {
    Announcement,
    Apps,
    Assignment,
    AssignmentInd,
    Ballot,
    BrandingWatermark,
    BubbleChart,
    Dashboard,
    DateRange,
    Description,
    Email,
    Help,
    List as ListIcon,
    Person,
    PieChart,
    SettingsApplications,
    Stop,
    VerticalSplit,
    Widgets,
    FormatQuote,
    Filter9Plus
} from "@mui/icons-material";
import {storybookData} from "../../../utilities/storybookData";

const menuItems = [
    { name: 'dashboard', text: 'Armaturenbrett', icon: <Dashboard />, to: '/dashboard'},
    {
        name: 'userContent',
        text: 'Teilnehmende',
        icon: <AssignmentInd/>,
        items: [
            { name: 'users', text: 'Nutzer', icon: <Person />, to: '/users' },
            { name: 'admin/projects', text: 'Projekte', icon: <Assignment />, to: '/admin/projects' },
        ]
    },
    {
        name: 'content',
        text: 'Inhalte',
        icon: <VerticalSplit/>,
        items: [
            { name: 'cta', text: 'Calls-To-Action', icon: <Announcement />, to: '/cta' },
            { name: 'menus', text: 'Navigation', icon: <ListIcon />, to: '/menus' },
            { name: 'pages', text: 'Seiten', icon: <Description />, to: '/pages' },
            {
                name: 'componentKit',
                text: 'ComponentKit',
                icon: <Apps />,
                items: Object.entries(
                    storybookData.reduce((acc, item) => {
                        const [parent, child] = item.split('--');
                        if (!acc[parent]) {
                            acc[parent] = [];
                        }
                        acc[parent].push(child);
                        return acc;
                    }, {})
                ).map(([parentName, children]) => ({
                    name: parentName,
                    text: parentName.replace(/-/g, ' ').split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
                    icon: <Widgets />,
                    items: children.map(childName => ({
                        name: `${parentName}-${childName}`,
                        text: childName.replace(/-/g, ' ').split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
                        to: `vorlagen/${parentName}--${childName}`,
                        icon: <Stop />,
                        sx: { pl: 3 }
                    }))
                }))
            },
        ]
    },
    {
        name: 'branding',
        text: 'Branding',
        icon: <BrandingWatermark/>,
        items: [
            { name: 'ecb', text: 'ECB', icon: <Ballot />, to: '/ecb' },
            { name: 'metrics', text: 'Engagement-Counter', icon: <Filter9Plus />, to: '/metrics' },
            { name: 'testimonials', text: 'Testimonial', icon: <FormatQuote/>, to: '/testimonials' },
        ]
    },
    {
        name: 'config',
        text: 'Einstellungen',
        icon: <SettingsApplications/>,
        items: [
            { name: 'email', text: 'E-Mail', icon: <Email />, to: '/email' },
            { name: 'phases', text: 'Phasen', icon: <DateRange/>, to: '/phases' },
        ]
    },
    { name: 'admin/surveys/questions', text: 'Umfragen', icon: <PieChart />, to: '/admin/surveys/questions' },
    { name: 'help', text: 'Hilfe', icon: <Help />, to: '/help' },
];

const CustomMenu = ({ onMenuClick, open, logout, ...props }) => {

    const renderMenu = (items) => {
        return items.map(item => {
            if (item.items && item.items.length > 0) {
                return (
                    <SubMenu
                        key={item.name}
                        sidebarIsOpen={open}
                        name={item.text}
                        icon={item.icon}>
                        {renderMenu(item.items)}
                    </SubMenu>
                )
            }
            return (
                <MenuItemLink
                    key={item.name}
                    to={item.to}
                    primaryText={item.text}
                    leftIcon={item.icon}
                    onClick={onMenuClick}
                    sx={item.sx}
                    style={{fontSize: ".9rem"}}
                />
            )
        })
    }

    return (
        <Menu {...props}>
            {renderMenu(menuItems)}
        </Menu>
    )
};

const CustomLayout = props => <Layout {...props} menu={CustomMenu}
                                      sx={{'& .RaLayout-content': {paddingLeft: '16px'}}}/>;

export default CustomLayout;